module.exports = __webpack_public_path__ + "img/circle-caret-down.1533656f.svg";